<template>
  <div class="page-not-found">
    <div class="container">
      <h1>Page Not Found</h1>
      <p>
        Sorry, we couldn't find the page you are looking for. It may have been
        removed, changed or is temporarily unavailable. Please return to our
        home page or see below our “Popular Searches” to continue browsing our
        site.
      </p>
      <div
        v-for="(placement, key) in recommendations"
        :key="key"
        class="js-nosto-placement"
      >
        <NostoProductRecommendationsGrid
          :recommendations="placement.products"
          :placement="key"
          :heading="placement.title"
          :overflow="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NostoProductRecommendationsGrid from "@/components/NostoProductRecommendationsGrid.vue";

export default {
  name: "PageNotFound",
  components: {
    NostoProductRecommendationsGrid,
  },
  data() {
    return {
      recommendations: [],
    };
  },
  created() {
    // eslint-disable-next-line no-undef
    nostojs((api) => {
      api
        .defaultSession()
        .viewNotFound()
        .setPlacements(["error-nosto-1"])
        .load()
        .then((data) => {
          const recommendations = data.recommendations;

          recommendations["error-nosto-1"].title = "AN EDIT JUST FOR YOU";

          this.recommendations = recommendations;
        });
    });
  },
};
</script>

<style lang="scss" scoped>
.page-not-found {
  background-image: url("@/assets/images/page-not-found--mobile.webp");
  background-position: top left;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  color: $color-white;

  @include respond-above(md) {
    background-image: url("@/assets/images/page-not-found--desktop.webp");
  }

  &::after {
    position: absolute;
    content: "";
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    background-color: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(5px); /* Supported in Chrome 76 */
  }
}

.container {
  position: relative;
  z-index: 1;
  padding-top: 60px;
  padding-bottom: 60px;

  @include respond-above(md) {
    padding-top: 80px;
    padding-bottom: 80px;
  }
}

h1 {
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 10px;

  @include respond-above(md) {
    font-size: 30px;
  }
}

p {
  font-family: $heading-font-family;
  font-size: 14px;

  @include respond-above(md) {
    font-size: 18px;
    max-width: 620px;
    width: auto;
  }
}
</style>
